module.exports = __webpack_public_path__ + "media/images/slide-17-382cadcde4cf5da5ff8d68b9fbf7e247.jpg";